import { ExpressPaymentsBaseService } from '../../../../js/Common/Payments/ExpressPaymentsBaseService';
import { useVehicleDetails } from '@vue3/src/Composables/VehicleDetails/useVehicleDetails';

export class ExpressPayments extends ExpressPaymentsBaseService {
  static async getVehicleDetails(vin = '') {
    let vehicleDetails = await useVehicleDetails(vin);
    return vehicleDetails;
  }
}
